module.exports = __webpack_public_path__ + "static/media/1 03 meteorolog.c69e02b0.mp3";